import { SVGAttributes } from 'react';

export const SortIcon = ({ className, ...rootProps }: SVGAttributes<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
        <path d="M8.75 11.875L15 18.125L21.25 11.875L8.75 11.875Z" fill="white" />
    </svg>
);

SortIcon.displayName = 'SortIcon';
